
const basePath = ""

export const loginUrl = `${basePath}/Login_controller/login`

export const getLoginDataUrl = `${basePath}/Login_controller/getLoginData`

export function viewAlbumUrl(link: string, lockCode:string): string {
    return `${basePath}/event_controller/viewAlbum/${link}?lock_code=${lockCode || ''}`
}

export function getAdsUrl(albumId: number): string {
    return basePath + `/event_controller/getAds/` + albumId
}

export const getTrendingUrl = basePath + "/event_gallery/getTrending"

export const uploadUrl = `${basePath}/event_gallery/do_upload`

export function getCommentsUrl(itemId:number): string {
    return `${basePath}/event_gallery/getComments/${itemId}`
}

export const addCommentsUrl = `${basePath}/event_gallery/addComment`